export interface IItemRankOption {
    id: number;
    label: string;
}

//  NOT sourced from `ItemRank` (removed from ItemEnums.ts): that enum was
//  stale -- it had only 7 members (no EPIC) and every id from UNIQUE onward
//  was shifted by one relative to what the search API actually expects for
//  `g=`. Verified live against duck (server/duck/items/search?name=sword&g=N
//  for N 0..7, ex=1): g=3 returns EPIC items, g=4 UNIQUE, g=5 LEGENDARY, g=6
//  DIVINE, g=7 ANCIENT -- exactly the eight-value encoding the pre-Task-7
//  page's own gradesToArray() used (0 normal .. 7 ancient), not the enum's.
//  filterToQuery's `g=` param and buildChips' 'ranks' group both already
//  pass ids straight through with no translation, so this list IS the
//  contract; keep it in sync with that verified server behaviour, not with
//  any numeric ItemRank-shaped enum, if the two are ever compared again.
//
//  Single source of truth for both ItemSearchRankSelector.vue (the popover
//  checkbox list) and ItemSearchEx.vue (RANK_LABELS, for chip text) -- these
//  used to be two hand-kept-in-sync copies.
export const ITEM_RANKS: IItemRankOption[] = [
    { id: 0, label: 'Normal' },
    { id: 1, label: 'Magic' },
    { id: 2, label: 'Rare' },
    { id: 3, label: 'Epic' },
    { id: 4, label: 'Unique' },
    { id: 5, label: 'Legendary' },
    { id: 6, label: 'Divine' },
    { id: 7, label: 'Ancient' },
];
